<dspx-card-set-base-form [fieldTypeReplacements]="fieldTypeReplacements"
                         [formServiceEndpoint]="formServiceEndpoint"
                         [templateId]="templateId"
                         [versionNo]="versionNo"
                         formName="GBH Form"
                         [entityId]="id"
                         (onFormLoad)="formLoaded($event)"
                         (onModelChange)="modelChanged($event)"
                         (onDialogSubmit)="dialogSubmitted($event)"
                         (onActionButtonClick)="actionButtonClicked($event)"
                         (onSave)="save($event)"
                         (onCancel)="cancel($event)"
                         [verticalNavigationSettings] = "verticalNavigationSettings">
</dspx-card-set-base-form>
